import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon/Icon';
import css from './SearchInput.module.css';

/**
 * The pill-shaped search box from the Components board ("Search Live Rooms, artists, shows").
 * `label` names it; with `showLabel` (and an `id`) it shows above the box, as on the board,
 * otherwise it is for screen readers only. Other props go to the input.
 */
const SearchInput = props => {
  const { rootClassName, className, label, showLabel, id, ...inputProps } = props;
  const visibleLabel = showLabel && id;
  return (
    <div className={classNames(rootClassName || css.root, className)}>
      {visibleLabel ? <label htmlFor={id}>{label}</label> : null}
      <div className={css.box}>
        <Icon name="search" size={16} className={css.icon} />
        <input
          type="search"
          id={id || undefined}
          className={css.input}
          aria-label={visibleLabel ? undefined : label}
          {...inputProps}
        />
      </div>
    </div>
  );
};

SearchInput.defaultProps = { rootClassName: null, className: null, showLabel: false, id: null };

SearchInput.propTypes = {
  rootClassName: string,
  className: string,
  label: string.isRequired,
  showLabel: bool,
  id: string,
};

export default SearchInput;
